/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ગઈકાલે",
        "-2": "ગયા પરમદિવસે",
        "0": "આજે",
        "1": "આવતીકાલે",
        "2": "પરમદિવસે",
        "future": {
          "one": "{0} દિવસમાં",
          "other": "{0} દિવસમાં"
        },
        "past": {
          "one": "{0} દિવસ પહેલાં",
          "other": "{0} દિવસ પહેલાં"
        }
      },
      "day-narrow": {
        "-1": "ગઈકાલે",
        "-2": "ગયા પરમદિવસે",
        "0": "આજે",
        "1": "આવતીકાલે",
        "2": "પરમદિવસે",
        "future": {
          "one": "{0} દિવસમાં",
          "other": "{0} દિવસમાં"
        },
        "past": {
          "one": "{0} દિવસ પહેલાં",
          "other": "{0} દિવસ પહેલાં"
        }
      },
      "day-short": {
        "-1": "ગઈકાલે",
        "-2": "ગયા પરમદિવસે",
        "0": "આજે",
        "1": "આવતીકાલે",
        "2": "પરમદિવસે",
        "future": {
          "one": "{0} દિવસમાં",
          "other": "{0} દિવસમાં"
        },
        "past": {
          "one": "{0} દિવસ પહેલાં",
          "other": "{0} દિવસ પહેલાં"
        }
      },
      "hour": {
        "0": "આ કલાક",
        "future": {
          "one": "{0} કલાકમાં",
          "other": "{0} કલાકમાં"
        },
        "past": {
          "one": "{0} કલાક પહેલાં",
          "other": "{0} કલાક પહેલાં"
        }
      },
      "hour-narrow": {
        "0": "આ કલાક",
        "future": {
          "one": "{0} કલાકમાં",
          "other": "{0} કલાકમાં"
        },
        "past": {
          "one": "{0} કલાક પહેલાં",
          "other": "{0} કલાક પહેલાં"
        }
      },
      "hour-short": {
        "0": "આ કલાક",
        "future": {
          "one": "{0} કલાકમાં",
          "other": "{0} કલાકમાં"
        },
        "past": {
          "one": "{0} કલાક પહેલાં",
          "other": "{0} કલાક પહેલાં"
        }
      },
      "minute": {
        "0": "આ મિનિટ",
        "future": {
          "one": "{0} મિનિટમાં",
          "other": "{0} મિનિટમાં"
        },
        "past": {
          "one": "{0} મિનિટ પહેલાં",
          "other": "{0} મિનિટ પહેલાં"
        }
      },
      "minute-narrow": {
        "0": "આ મિનિટ",
        "future": {
          "one": "{0} મિનિટમાં",
          "other": "{0} મિનિટમાં"
        },
        "past": {
          "one": "{0} મિનિટ પહેલાં",
          "other": "{0} મિનિટ પહેલાં"
        }
      },
      "minute-short": {
        "0": "આ મિનિટ",
        "future": {
          "one": "{0} મિનિટમાં",
          "other": "{0} મિનિટમાં"
        },
        "past": {
          "one": "{0} મિનિટ પહેલાં",
          "other": "{0} મિનિટ પહેલાં"
        }
      },
      "month": {
        "-1": "ગયા મહિને",
        "0": "આ મહિને",
        "1": "આવતા મહિને",
        "future": {
          "one": "{0} મહિનામાં",
          "other": "{0} મહિનામાં"
        },
        "past": {
          "one": "{0} મહિના પહેલાં",
          "other": "{0} મહિના પહેલાં"
        }
      },
      "month-narrow": {
        "-1": "ગયા મહિને",
        "0": "આ મહિને",
        "1": "આવતા મહિને",
        "future": {
          "one": "{0} મહિનામાં",
          "other": "{0} મહિનામાં"
        },
        "past": {
          "one": "{0} મહિના પહેલાં",
          "other": "{0} મહિના પહેલાં"
        }
      },
      "month-short": {
        "-1": "ગયા મહિને",
        "0": "આ મહિને",
        "1": "આવતા મહિને",
        "future": {
          "one": "{0} મહિનામાં",
          "other": "{0} મહિનામાં"
        },
        "past": {
          "one": "{0} મહિના પહેલાં",
          "other": "{0} મહિના પહેલાં"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "છેલ્લું ત્રિમાસિક",
        "0": "આ ત્રિમાસિક",
        "1": "પછીનું ત્રિમાસિક",
        "future": {
          "one": "{0} ત્રિમાસિકમાં",
          "other": "{0} ત્રિમાસિકમાં"
        },
        "past": {
          "one": "{0} ત્રિમાસિક પહેલાં",
          "other": "{0} ત્રિમાસિક પહેલાં"
        }
      },
      "quarter-narrow": {
        "-1": "છેલ્લું ત્રિમાસિક",
        "0": "આ ત્રિમાસિક",
        "1": "પછીનું ત્રિમાસિક",
        "future": {
          "one": "{0} ત્રિમાસિકમાં",
          "other": "{0} ત્રિમાસિકમાં"
        },
        "past": {
          "one": "{0} ત્રિમાસિક પહેલાં",
          "other": "{0} ત્રિમાસિક પહેલાં"
        }
      },
      "quarter-short": {
        "-1": "છેલ્લું ત્રિમાસિક",
        "0": "આ ત્રિમાસિક",
        "1": "પછીનું ત્રિમાસિક",
        "future": {
          "one": "{0} ત્રિમાસિકમાં",
          "other": "{0} ત્રિમાસિકમાં"
        },
        "past": {
          "one": "{0} ત્રિમાસિક પહેલાં",
          "other": "{0} ત્રિમાસિક પહેલાં"
        }
      },
      "second": {
        "0": "હમણાં",
        "future": {
          "one": "{0} સેકંડમાં",
          "other": "{0} સેકંડમાં"
        },
        "past": {
          "one": "{0} સેકંડ પહેલાં",
          "other": "{0} સેકંડ પહેલાં"
        }
      },
      "second-narrow": {
        "0": "હમણાં",
        "future": {
          "one": "{0} સેકંડમાં",
          "other": "{0} સેકંડમાં"
        },
        "past": {
          "one": "{0} સેકંડ પહેલાં",
          "other": "{0} સેકંડ પહેલાં"
        }
      },
      "second-short": {
        "0": "હમણાં",
        "future": {
          "one": "{0} સેકંડમાં",
          "other": "{0} સેકંડમાં"
        },
        "past": {
          "one": "{0} સેકંડ પહેલાં",
          "other": "{0} સેકંડ પહેલાં"
        }
      },
      "week": {
        "-1": "ગયા અઠવાડિયે",
        "0": "આ અઠવાડિયે",
        "1": "આવતા અઠવાડિયે",
        "future": {
          "one": "{0} અઠવાડિયામાં",
          "other": "{0} અઠવાડિયામાં"
        },
        "past": {
          "one": "{0} અઠવાડિયા પહેલાં",
          "other": "{0} અઠવાડિયા પહેલાં"
        }
      },
      "week-narrow": {
        "-1": "ગયા અઠવાડિયે",
        "0": "આ અઠવાડિયે",
        "1": "આવતા અઠવાડિયે",
        "future": {
          "one": "{0} અઠ. માં",
          "other": "{0} અઠ. માં"
        },
        "past": {
          "one": "{0} અઠ. પહેલાં",
          "other": "{0} અઠ. પહેલાં"
        }
      },
      "week-short": {
        "-1": "ગયા અઠવાડિયે",
        "0": "આ અઠવાડિયે",
        "1": "આવતા અઠવાડિયે",
        "future": {
          "one": "{0} અઠ. માં",
          "other": "{0} અઠ. માં"
        },
        "past": {
          "one": "{0} અઠ. પહેલાં",
          "other": "{0} અઠ. પહેલાં"
        }
      },
      "year": {
        "-1": "ગયા વર્ષે",
        "0": "આ વર્ષે",
        "1": "આવતા વર્ષે",
        "future": {
          "one": "{0} વર્ષમાં",
          "other": "{0} વર્ષમાં"
        },
        "past": {
          "one": "{0} વર્ષ પહેલાં",
          "other": "{0} વર્ષ પહેલાં"
        }
      },
      "year-narrow": {
        "-1": "ગયા વર્ષે",
        "0": "આ વર્ષે",
        "1": "આવતા વર્ષે",
        "future": {
          "one": "{0} વર્ષમાં",
          "other": "{0} વર્ષમાં"
        },
        "past": {
          "one": "{0} વર્ષ પહેલાં",
          "other": "{0} વર્ષ પહેલાં"
        }
      },
      "year-short": {
        "-1": "ગયા વર્ષે",
        "0": "આ વર્ષે",
        "1": "આવતા વર્ષે",
        "future": {
          "one": "{0} વર્ષમાં",
          "other": "{0} વર્ષમાં"
        },
        "past": {
          "one": "{0} વર્ષ પહેલાં",
          "other": "{0} વર્ષ પહેલાં"
        }
      }
    },
    "locale": "gu"
  });
}